import { APITransport } from '@client/transports/api';

export const CampaignsService = {
  async getAll() {
    const response = await APITransport.get({
      path: '/rest/domain/ads'
    });

    return Array.isArray(response) ? response : [];
  },
  async getById(id) {
    const tags = await CampaignsService.getAll();
    return tags.find(({ rulename }) => rulename === id);
  },
  async getCampaign(id) {
    return APITransport.get({
      path: `/rest/domain/ads/${id}`
    });
  },
  getMetrics(query) {
    return APITransport.get({
      path: '/rest/domain/report/getadreport?internalOnly=true',
      query
    });
  },
  async createCampaign(body = {}) {
    return APITransport.post({
      path: '/rest/domain/save/ads',
      body
    });
  },
  async updateCampaign(body = {}) {
    return APITransport.post({
      path: '/rest/domain/save/ads',
      body
    });
  },
  async deleteCampaign(body = {}) {
    return APITransport.post({
      path: '/rest/domain/delete/ads',
      body
    });
  },
  async getDocumentList() {
    return APITransport.get({
      path: '/rest/listofvalues/listdocuments?query='
    });
  },
  async getVideoList() {
    return APITransport.get({
      path: '/rest/listofvalues/listvideos?query='
    });
  }
};
